export default {
  setUser(state, payload) {
    state.user = payload;
  },
  setUserLoginError(state, payload) {
    state.userLoginError = payload;
  },

  loginButtonLoading(state, payload) {
    state.loginButtonLoading = payload;
  },

  setRegistrationError(state, payload) {
    state.userRegistrationError = payload;
  },

  registerButtonLoading(state, payload) {
    state.registerButtonLoading = payload;
  },

  showLoginSuccess(state, payload) {
    state.loginSuccess = payload;
  }
};
